import React from 'react';

const Card = ({ children, className = '', onClick, hoverable = true }) => {
  const hoverClasses = hoverable ? 'hover:shadow-xl transition-shadow duration-300' : '';
  
  return (
    <div 
      className={`card ${hoverClasses} ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default Card;
